import React from "react";
import {Row, Col, Button, ButtonToolbar, Tab} from "react-bootstrap";
import SshKeyTableRow from "./account-table-sshkey-row"
import FontAwesome from "react-fontawesome";
import UserHandler from "../../utilities/user-handler";
import * as config from "../../config";
import Api from "../../utilities/fnapi-client";
import { Link } from "react-router";

/**
 * We probably need support for multiple SFTP accounts per application
 * I'm not sure if we should be returning other information like regions here,
 * if so we'll need to do some API work, AFAIK only one client has multiple SFTP accounts per app
 */
export default React.createClass({

  render: function() {

    var label = 'username';
    if (this.props.sftpAccounts.length > 1){
      label = 'usernames'
    }

    return (
      <div className="SFTP Accounts">

        <p>
          <strong>
            {label}:&nbsp;
          </strong>
          <span>
            { this.props.sftpAccounts.map(t => { return t.username } ).reduce((prev, curr) => [prev, ', ', curr]) }
          </span>


          <br /><strong>host:</strong> logs.facetec.com (54.70.182.147)
          <br /><strong>port:</strong> 22
          <br /><strong>naming convention:</strong> facetec-usage-logs-[DATE]-[Server ID or Guid].txt
        </p>
      </div>

    );
  },


});



// WEBPACK FOOTER //
// ./src/js/components/account/account-table-sftp-accounts.jsx